import { Stack } from '@mui/material';

import { CalendarMeetingDto } from '@/api/generated';
import { EmptyTasks } from '@/components/TaskRow/EmptyTasks';
import TaskRow from '@/components/TaskRow/TaskRow';
import useIntegrations from '@/hooks/Integrations/useIntegrations';
import useTasks from '@/hooks/useTasks';

const MeetingMyTasks = ({ meeting }: { meeting: CalendarMeetingDto | undefined }) => {
  const { taskList, refetchTasks } = useTasks(undefined, meeting?.id);
  const { userGrant } = useIntegrations();

  return (
    <Stack flex={1}>
      {taskList.length ? (
        taskList.map(task => (
          <TaskRow
            key={task.id}
            task={task}
            provider={userGrant?.provider}
            refetchTasks={refetchTasks}
          />
        ))
      ) : (
        <EmptyTasks hideButton={true} containerStyling={{ minHeight: '400px' }} />
      )}
    </Stack>
  );
};
export default MeetingMyTasks;
